<template>
  <div class="visao-geral-etiqueta-page">
    <div class="dashboard-header mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div class="dashboard-header-titulo-row d-flex align-items-center flex-wrap">
          <router-link
            :to="{ name: 'chat-etiquetas', query: queryVoltar }"
            class="btn-voltar-etiqueta mr-2"
            title="Voltar para Etiquetas"
          >
            <feather-icon icon="ArrowLeftIcon" size="20" />
          </router-link>
          <h2 class="dashboard-title">
            <feather-icon icon="TagIcon" size="32" class="titulo-icon-left" />
            <span class="titulo-texto">Visão geral da Etiqueta {{ nomeEtiqueta || '—' }}</span>
            <router-link
              :to="{ name: 'dashboard-main' }"
              class="dashboard-header-home"
              title="Ir para o início"
            >
              <feather-icon icon="HomeIcon" size="16" class="dashboard-header-home-icon" />
            </router-link>
          </h2>
        </div>
        <p class="text-muted mb-0 w-100 dashboard-header-subtitle">
          Gráficos por dia: conversas, mensagens, tempos e resoluções
        </p>
      </div>
    </div>

    <b-card
      v-if="facebookAccountsLista.length > 1"
      class="mb-4 card-selecao-loja"
    >
      <div class="d-flex flex-wrap align-items-center">
        <feather-icon icon="StoreIcon" size="18" class="mr-2 text-primary" />
        <label class="mb-0 mr-3 font-weight-bold">Selecionar Loja:</label>
        <b-form-select
          v-model="uuid"
          :options="facebookAccountsLista.map(conta => ({
            value: conta.chat_token,
            text: conta.name,
          }))"
          class="select-loja"
          @change="carregarDados"
        />
      </div>
    </b-card>

    <b-card v-if="nomeEtiqueta && textoFiltrosAplicados" class="mb-4 filtros-aplicados-card">
      <h6 class="filtros-aplicados-titulo mb-2">
        <feather-icon icon="FilterIcon" size="18" class="mr-1" />
        Filtros aplicados (herdados da página Etiquetas)
      </h6>
      <p class="text-muted small mb-0">{{ textoFiltrosAplicados }}</p>
    </b-card>

    <div v-if="!nomeEtiqueta" class="text-center text-muted py-5">
      Nenhuma etiqueta selecionada. Volte à lista de etiquetas.
    </div>

    <template v-else>
      <div class="charts-grid">
        <b-card class="chart-card">
          <h6 class="chart-title">Conversas por dia</h6>
          <vue-apex-chart
            type="bar"
            height="280"
            :options="opcoesBarra"
            :series="seriesConversas"
          />
        </b-card>
        <b-card class="chart-card">
          <h6 class="chart-title">Mensagens enviadas por dia</h6>
          <vue-apex-chart
            type="bar"
            height="280"
            :options="opcoesBarra"
            :series="seriesMensagensEnviadas"
          />
        </b-card>
        <b-card class="chart-card">
          <h6 class="chart-title">Mensagens recebidas por dia</h6>
          <vue-apex-chart
            type="bar"
            height="280"
            :options="opcoesBarra"
            :series="seriesMensagensRecebidas"
          />
        </b-card>
        <b-card class="chart-card">
          <h6 class="chart-title">Tempo médio da primeira resposta (min) por dia</h6>
          <vue-apex-chart
            type="bar"
            height="280"
            :options="opcoesBarra"
            :series="seriesTempoPrimeiraResposta"
          />
        </b-card>
        <b-card class="chart-card">
          <h6 class="chart-title">Tempo médio de resolução (min) por dia</h6>
          <vue-apex-chart
            type="bar"
            height="280"
            :options="opcoesBarra"
            :series="seriesTempoResolucao"
          />
        </b-card>
        <b-card class="chart-card">
          <h6 class="chart-title">Resoluções por dia</h6>
          <vue-apex-chart
            type="bar"
            height="280"
            :options="opcoesBarra"
            :series="seriesResolucoes"
          />
        </b-card>
      </div>
    </template>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { buscaResolvidos, buscaMensagensPorTag, buscaChatsTeste } from '../../functions/basics/chat'

function dataChave(at) {
  const d = at.inicio ? new Date(at.inicio) : (at.fim ? new Date(at.fim) : (at.data_resolucao ? new Date(at.data_resolucao) : null))
  if (!d || Number.isNaN(d.getTime())) return null
  return d.toISOString().slice(0, 10)
}

function pertenceEtiqueta(at, nomeEtiqueta) {
  if (nomeEtiqueta === 'Sem etiqueta') {
    const tags = (at.tags || []).map(t => (typeof t === 'string' ? t.trim() : (t.nome || t.name || '').toString().trim())).filter(Boolean)
    return tags.length === 0
  }
  const tags = (at.tags || []).map(t => (typeof t === 'string' ? t.trim() : (t.nome || t.name || '').toString().trim())).filter(Boolean)
  return tags.includes(nomeEtiqueta)
}

function refPrimeiraResposta(at) {
  const usoInicio = at.atendimento_bot === false && (at.fim_bot == null || at.fim_bot === undefined)
  if (usoInicio && at.inicio) return new Date(at.inicio).getTime()
  if (at.fim_bot) return new Date(at.fim_bot).getTime()
  return null
}

/**
 * Minutos entre inicio e fim que caem dentro do horario_funcionamento.
 */
function minutosDentroDoHorario(inicioTimestamp, fimTimestamp, horarioFuncionamento) {
  if (!inicioTimestamp || !fimTimestamp || !horarioFuncionamento || !horarioFuncionamento.length) return null
  const inicio = new Date(inicioTimestamp)
  const fim = new Date(fimTimestamp)
  if (Number.isNaN(inicio.getTime()) || Number.isNaN(fim.getTime()) || inicio >= fim) return 0
  let totalMin = 0
  const dayStart = new Date(inicio.getFullYear(), inicio.getMonth(), inicio.getDate(), 0, 0, 0, 0)
  const dayEnd = new Date(fim.getFullYear(), fim.getMonth(), fim.getDate(), 23, 59, 59, 999)
  let d = new Date(dayStart)
  while (d <= dayEnd) {
    const dia = d.getDay()
    const year = d.getFullYear()
    const month = d.getMonth()
    const date = d.getDate()
    const intervalos = horarioFuncionamento.filter(h => h.dia === dia)
    for (let i = 0; i < intervalos.length; i++) {
      const int = intervalos[i]
      const [abreH, abreM] = (int.abre || '00:00').split(':').map(Number)
      const [fechaH, fechaM] = (int.fecha || '23:59').split(':').map(Number)
      const intervalStart = new Date(year, month, date, abreH || 0, abreM || 0, 0, 0)
      const intervalEnd = new Date(year, month, date, fechaH || 23, fechaM || 59, 59, 999)
      const overlapStart = new Date(Math.max(inicio.getTime(), intervalStart.getTime()))
      const overlapEnd = new Date(Math.min(fim.getTime(), intervalEnd.getTime()))
      if (overlapStart < overlapEnd) {
        totalMin += (overlapEnd.getTime() - overlapStart.getTime()) / 60000
      }
    }
    d.setDate(d.getDate() + 1)
  }
  return totalMin
}

/**
 * Tempo em minutos até a primeira resposta.
 * Regra: média das diferenças entre fim_bot e primeira_mensagem_atendente_em.
 * Se atendimento_bot = false e fim_bot = null, usa diferença entre inicio e primeira_mensagem_atendente_em.
 */
function calcularTempoPrimeiraRespostaMin(at) {
  const primeiraRespostaEm = at.primeira_mensagem_atendente_em ? new Date(at.primeira_mensagem_atendente_em).getTime() : null
  if (primeiraRespostaEm == null || Number.isNaN(primeiraRespostaEm)) return null
  const usoInicio = at.atendimento_bot === false && (at.fim_bot == null || at.fim_bot === undefined)
  const ref = usoInicio
    ? (at.inicio ? new Date(at.inicio).getTime() : null)
    : (at.fim_bot ? new Date(at.fim_bot).getTime() : null)
  if (ref == null || Number.isNaN(ref)) return null
  return (primeiraRespostaEm - ref) / 1000 / 60
}

export default {
  name: 'VisaoGeralEtiqueta',
  components: { 'vue-apex-chart': VueApexCharts },
  data() {
    const fim = new Date()
    const inicio = new Date()
    inicio.setDate(fim.getDate() - 6)
    return {
      facebookAccountsLista: [],
      uuid: null,
      carregando: false,
      periodoInicio: inicio,
      periodoFim: fim,
      atalhoDias: 7,
      periodoCardAberto: false,
      considerarHorarioAtendimento: false,
      resolvidos: [],
      /** Dados do endpoint messages-by-tag: { "YYYY-MM-DD": { mensagens_trocadas, mensagens_enviadas }, ... } */
      mensagensPorDiaApi: {},
      opcoesBarraBase: {
        chart: { toolbar: { show: false } },
        plotOptions: {
          bar: {
            borderRadius: 6,
            columnWidth: '60%',
          },
        },
        dataLabels: { enabled: false },
        xaxis: {
          labels: { rotate: -45 },
        },
        colors: ['#9A3092'],
      },
    }
  },
  computed: {
    periodoTriggerLabel() {
      if (this.atalhoDias === 7) return 'Últimos 7 dias'
      if (this.atalhoDias === 15) return 'Últimos 15 dias'
      if (this.atalhoDias === 31) return 'Últimos 31 dias'
      return 'Período personalizado'
    },
    periodoTriggerRange() {
      const i = this.periodoInicio ? new Date(this.periodoInicio) : null
      const f = this.periodoFim ? new Date(this.periodoFim) : null
      if (!i || !f) return ''
      const fmt = d => d.toLocaleDateString('pt-BR', { day: 'numeric', month: 'short', year: 'numeric' })
      return `${fmt(i)} - ${fmt(f)}`
    },
    nomeEtiqueta() {
      const q = (this.$route.query.etiqueta || '').toString().trim()
      return q || ''
    },
    horarioSelecionado() {
      const chat = this.facebookAccountsLista.find(c => c.chat_token === this.uuid)
      return chat?.horario_funcionamento || []
    },
    queryVoltar() {
      const q = {}
      if (this.uuid) q.uuid = this.uuid
      const i = this.periodoInicio ? new Date(this.periodoInicio) : null
      const f = this.periodoFim ? new Date(this.periodoFim) : null
      const fmt = d => d && !Number.isNaN(d.getTime()) ? d.toISOString().slice(0, 10) : null
      if (fmt(i)) q.periodo_inicio = fmt(i)
      if (fmt(f)) q.periodo_fim = fmt(f)
      q.considerar_horario = this.considerarHorarioAtendimento ? '1' : '0'
      return q
    },
    textoFiltrosAplicados() {
      const partes = []
      const i = this.periodoInicio ? new Date(this.periodoInicio) : null
      const f = this.periodoFim ? new Date(this.periodoFim) : null
      if (i && f && !Number.isNaN(i.getTime()) && !Number.isNaN(f.getTime())) {
        const fmt = d => d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' })
        partes.push(`Período: ${fmt(i)} a ${fmt(f)}`)
      }
      const chat = this.facebookAccountsLista.find(c => c.chat_token === this.uuid)
      if (chat && (chat.name || chat.chat_token)) {
        partes.push(`Loja: ${chat.name || chat.chat_token}`)
      }
      partes.push(`Considerar somente horário de atendimento: ${this.considerarHorarioAtendimento ? 'Sim' : 'Não'}`)
      if (this.considerarHorarioAtendimento && this.horarioSelecionado.length) {
        const nomesDia = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
        const porDia = {}
        this.horarioSelecionado.forEach(({ dia, abre, fecha }) => {
          if (!porDia[dia]) porDia[dia] = []
          porDia[dia].push(`${abre || ''}–${fecha || ''}`)
        })
        const txt = Object.keys(porDia)
          .sort((a, b) => Number(a) - Number(b))
          .map(d => `${nomesDia[Number(d)]}: ${porDia[d].join(', ')}`)
          .join(' | ')
        partes.push(`Horários: ${txt}`)
      }
      return partes.join(' · ')
    },
    atendimentosFiltrados() {
      const nome = this.nomeEtiqueta
      if (!nome) return []
      return (this.resolvidos || []).filter(at => pertenceEtiqueta(at, nome))
    },
    metricasPorDia() {
      const nome = this.nomeEtiqueta
      if (!nome) return {}
      const horario = this.horarioSelecionado
      const considerarHorario = this.considerarHorarioAtendimento && horario.length > 0
      const porDia = {}
      this.atendimentosFiltrados.forEach(at => {
        const key = dataChave(at)
        if (!key) return
        if (!porDia[key]) {
          porDia[key] = {
            conversas: 0,
            mensagensEnviadas: 0,
            mensagensRecebidas: 0,
            somaPrimeiraResposta: 0,
            countPrimeiraResposta: 0,
            somaResolucao: 0,
            countResolucao: 0,
            resolucoes: 0,
          }
        }
        porDia[key].conversas += 1
        if (at.primeira_mensagem_atendente_em) {
          const ref = refPrimeiraResposta(at)
          let pr = null
          if (ref != null) {
            pr = considerarHorario
              ? minutosDentroDoHorario(ref, new Date(at.primeira_mensagem_atendente_em).getTime(), horario)
              : calcularTempoPrimeiraRespostaMin(at)
          }
          if (pr != null && !Number.isNaN(pr)) {
            porDia[key].countPrimeiraResposta += 1
            porDia[key].somaPrimeiraResposta += pr
          }
        }
        const fim = at.fim || at.data_resolucao || at.ultima_mensagem_em
        const inicioAt = at.inicio ? new Date(at.inicio).getTime() : null
        const fimAt = fim ? new Date(fim).getTime() : null
        if (inicioAt && fimAt) {
          const min = considerarHorario
            ? minutosDentroDoHorario(inicioAt, fimAt, horario)
            : (fimAt - inicioAt) / 1000 / 60
          if (min != null && !Number.isNaN(min)) {
            porDia[key].somaResolucao += min
            porDia[key].countResolucao += 1
          }
        }
        if (fim) porDia[key].resolucoes += 1
      })
      const api = this.mensagensPorDiaApi || {}
      const diasApi = Object.keys(api)
      diasApi.forEach(key => {
        if (!porDia[key]) {
          porDia[key] = {
            conversas: 0,
            mensagensEnviadas: 0,
            mensagensRecebidas: 0,
            somaPrimeiraResposta: 0,
            countPrimeiraResposta: 0,
            somaResolucao: 0,
            countResolucao: 0,
            resolucoes: 0,
          }
        }
        const v = api[key]
        if (v && typeof v === 'object') {
          if (v.mensagens_enviadas != null) porDia[key].mensagensEnviadas = Number(v.mensagens_enviadas) || 0
          if (v.mensagens_recebidas != null) porDia[key].mensagensRecebidas = Number(v.mensagens_recebidas) || 0
        }
      })
      return porDia
    },
    diasOrdenados() {
      return Object.keys(this.metricasPorDia).sort()
    },
    labelsDias() {
      return this.diasOrdenados.map(d => {
        const [y, m, day] = d.split('-').map(Number)
        const date = new Date(y, m - 1, day)
        return date.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' })
      })
    },
    seriesConversas() {
      return [{
        name: 'Conversas',
        data: this.diasOrdenados.map(d => this.metricasPorDia[d].conversas),
      }]
    },
    seriesMensagensEnviadas() {
      return [{
        name: 'Mensagens enviadas',
        data: this.diasOrdenados.map(d => this.metricasPorDia[d].mensagensEnviadas),
      }]
    },
    seriesMensagensRecebidas() {
      return [{
        name: 'Mensagens recebidas',
        data: this.diasOrdenados.map(d => this.metricasPorDia[d].mensagensRecebidas),
      }]
    },
    seriesTempoPrimeiraResposta() {
      return [{
        name: 'Tempo 1ª resposta (min)',
        data: this.diasOrdenados.map(d => {
          const m = this.metricasPorDia[d]
          const v = m.countPrimeiraResposta ? m.somaPrimeiraResposta / m.countPrimeiraResposta : 0
          return Math.round(v * 10) / 10
        }),
      }]
    },
    seriesTempoResolucao() {
      return [{
        name: 'Tempo resolução (min)',
        data: this.diasOrdenados.map(d => {
          const m = this.metricasPorDia[d]
          const v = m.countResolucao ? m.somaResolucao / m.countResolucao : 0
          return Math.round(v * 10) / 10
        }),
      }]
    },
    seriesResolucoes() {
      return [{
        name: 'Resoluções',
        data: this.diasOrdenados.map(d => this.metricasPorDia[d].resolucoes),
      }]
    },
    opcoesBarra() {
      return {
        ...this.opcoesBarraBase,
        xaxis: {
          ...this.opcoesBarraBase.xaxis,
          categories: this.labelsDias,
        },
      }
    },
  },
  watch: {
    '$route.query': {
      handler() {
        this.aplicarPeriodoDaQuery()
        this.sincronizarUuid()
        if (this.nomeEtiqueta && this.uuid) this.carregarDados()
      },
      deep: true,
    },
    periodoInicio() {
      this.atualizarAtalhoDiasPelasDatas()
    },
    periodoFim() {
      this.atualizarAtalhoDiasPelasDatas()
    },
  },
  created() {
    this.aplicarPeriodoDaQuery()
  },
  mounted() {
    this.sincronizarUuid()
    this.carregarLojas().then(() => {
      if (this.nomeEtiqueta && this.uuid) this.carregarDados()
    })
  },
  methods: {
    aplicarPeriodoDaQuery() {
      const q = this.$route.query
      const qi = q.periodo_inicio
      const qf = q.periodo_fim
      if (qi && qf) {
        const i = new Date(qi)
        const f = new Date(qf)
        if (!Number.isNaN(i.getTime()) && !Number.isNaN(f.getTime())) {
          this.periodoInicio = i
          this.periodoFim = f
          this.atualizarAtalhoDiasPelasDatas()
        }
      }
      if (q.considerar_horario === '1') this.considerarHorarioAtendimento = true
      else if (q.considerar_horario === '0') this.considerarHorarioAtendimento = false
    },
    sincronizarUuid() {
      const q = this.$route.query.uuid
      if (q) this.uuid = q
      else if (this.facebookAccountsLista.length === 1) this.uuid = this.facebookAccountsLista[0].chat_token
    },
    aplicarPeriodo(dias) {
      const fim = new Date()
      const inicio = new Date()
      inicio.setDate(fim.getDate() - dias + 1)
      this.periodoInicio = inicio
      this.periodoFim = fim
      this.atalhoDias = dias
    },
    limparPeriodo() {
      this.aplicarPeriodo(7)
    },
    selecionarPersonalizado() {
      this.atalhoDias = null
    },
    atualizarAtalhoDiasPelasDatas() {
      const i = this.periodoInicio ? new Date(this.periodoInicio) : null
      const f = this.periodoFim ? new Date(this.periodoFim) : null
      if (!i || !f || Number.isNaN(i.getTime()) || Number.isNaN(f.getTime())) return
      const diffDias = Math.round((f - i) / (1000 * 60 * 60 * 24)) + 1
      if (diffDias === 7) this.atalhoDias = 7
      else if (diffDias === 15) this.atalhoDias = 15
      else if (diffDias === 31) this.atalhoDias = 31
      else this.atalhoDias = null
    },
    aplicarPeriodoEBuscar() {
      this.periodoCardAberto = false
      this.carregarDados()
    },
    async carregarLojas() {
      const contas = await buscaChatsTeste()
      this.facebookAccountsLista = contas.chats || []
      this.sincronizarUuid()
    },
    async carregarDados() {
      const nome = this.nomeEtiqueta
      const accountId = this.uuid
      if (!nome || !accountId) return
      const inicio = new Date(this.periodoInicio)
      const fim = new Date(this.periodoFim)
      if (fim < inicio) {
        this.$bvToast.toast('Data final deve ser maior ou igual à inicial.', { title: 'Atenção', variant: 'warning', solid: true })
        return
      }
      const diffDias = Math.ceil((fim - inicio) / (1000 * 60 * 60 * 24))
      if (diffDias > 31) {
        this.$bvToast.toast('O período não pode exceder 31 dias.', { title: 'Atenção', variant: 'warning', solid: true })
        return
      }
      this.carregando = true
      const inicioISO = inicio.toISOString().split('T')[0]
      const fimISO = fim.toISOString().split('T')[0]
      try {
        const [res, msgRes] = await Promise.all([
          buscaResolvidos(accountId, inicioISO, fimISO, 'all'),
          buscaMensagensPorTag(accountId, nome, inicioISO, fimISO).catch(() => null),
        ])
        this.resolvidos = res?.resolvidos || []
        this.mensagensPorDiaApi = this.normalizarMensagensPorDiaApi(msgRes)
      } catch (err) {
        console.error('Erro ao carregar dados da etiqueta:', err)
        this.$bvToast.toast(err.message || 'Erro ao carregar dados.', { title: 'Erro', variant: 'danger', solid: true })
        this.resolvidos = []
        this.mensagensPorDiaApi = {}
      } finally {
        this.carregando = false
      }
    },
    /**
     * Agrega resposta do GET /api/report/messages-by-tag (array mensagens) em por dia.
     * Retorna { "YYYY-MM-DD": { mensagens_enviadas, mensagens_recebidas }, ... }
     * - mensagens_enviadas: mensagens com atendente_id != null
     * - mensagens_recebidas: mensagens com remetente === 'cliente'
     */
    normalizarMensagensPorDiaApi(data) {
      if (!data || !Array.isArray(data.mensagens)) return {}
      const porDia = {}
      data.mensagens.forEach(msg => {
        const ts = msg.timestamp
        const key = typeof ts === 'string' ? ts.slice(0, 10) : (ts && ts.toISOString ? ts.toISOString().slice(0, 10) : null)
        if (!key) return
        if (!porDia[key]) porDia[key] = { mensagens_enviadas: 0, mensagens_recebidas: 0 }
        if (msg.atendente_id != null) porDia[key].mensagens_enviadas += 1
        if (msg.remetente === 'cliente') porDia[key].mensagens_recebidas += 1
      })
      return porDia
    },
  },
}
</script>

<style>
body:has(.visao-geral-etiqueta-page) .content-area-wrapper {
  overflow-y: auto !important;
  overflow-x: hidden !important;
  max-width: 100% !important;
  width: 100% !important;
}
body:has(.visao-geral-etiqueta-page) .app-content.content {
  padding-left: 0 !important;
  padding-right: 0 !important;
  max-width: 100% !important;
}
body:has(.visao-geral-etiqueta-page) .content-wrapper,
body:has(.visao-geral-etiqueta-page) .content-body {
  padding: 0 !important;
  margin: 0 !important;
  max-width: 100% !important;
}
body:has(.visao-geral-etiqueta-page) .content-right {
  width: 100% !important;
  max-width: 100% !important;
  flex: 1 1 auto !important;
  min-width: 0 !important;
}
</style>

<style scoped>
.visao-geral-etiqueta-page {
  padding: 1rem;
  min-height: 100vh;
  max-width: 100%;
  overflow-x: hidden;
}

.dashboard-header {
  background: linear-gradient(135deg, #9A3092 0%, #c44ab8 100%);
  padding: 1.25rem 1.5rem;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(154, 48, 146, 0.25);
}

.dashboard-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
  margin: 0;
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.dashboard-title .titulo-icon-left {
  flex-shrink: 0;
}

.dashboard-title .titulo-texto {
  line-height: 1;
}

.btn-voltar-etiqueta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.95);
  padding: 0.35rem;
  border-radius: 8px;
  transition: background 0.2s, color 0.2s;
}

.btn-voltar-etiqueta:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
}

.dashboard-header-home {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.95);
  padding: 0.2rem;
  border-radius: 8px;
  transition: background 0.2s, color 0.2s;
  flex-shrink: 0;
}

.dashboard-header-home:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
}

.dashboard-header .text-muted {
  color: rgba(255, 255, 255, 0.9) !important;
}

.dashboard-header-subtitle {
  margin-top: 0.15rem;
}

.card-selecao-loja .select-loja {
  max-width: 300px;
  min-width: 0;
}

.filtros-card.periodo-card {
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.filtros-aplicados-card {
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border-left: 4px solid #9A3092;
}

.filtros-aplicados-titulo {
  font-weight: 600;
  color: #5e5873;
  font-size: 0.95rem;
}

.periodo-card .card-body {
  padding: 1rem 1.25rem;
}

.periodo-card-trigger {
  cursor: pointer;
  padding: 0.25rem 0;
  user-select: none;
}

.periodo-trigger-icon {
  flex-shrink: 0;
}

.periodo-trigger-label {
  font-weight: 600;
  color: #5e5873;
}

.periodo-trigger-range {
  font-size: 0.9rem;
}

.periodo-trigger-chevron {
  flex-shrink: 0;
}

.periodo-card-body {
  border-top: 1px solid #ebe9f1;
  padding-top: 1rem;
}

.periodo-presets-title {
  font-weight: 600;
  color: #5e5873;
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
}

.periodo-presets-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.periodo-preset-btn {
  display: block;
  width: 100%;
  text-align: left;
  padding: 0.5rem 0.75rem;
  border: 1px solid #d8d6de;
  border-radius: 8px;
  background: #fff;
  color: #5e5873;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
}

.periodo-preset-btn:hover {
  background: #f8f9fa;
  border-color: #9A3092;
  color: #9A3092;
}

.periodo-preset-btn.active {
  background: #9A3092;
  border-color: #9A3092;
  color: #fff;
}

.periodo-field-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 500;
  color: #5e5873;
  margin-bottom: 0.35rem;
}

.periodo-datepicker >>> .form-control {
  border-radius: 8px;
  border-color: #d8d6de;
}

.periodo-card-footer {
  flex-wrap: wrap;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 1.25rem;
}

.chart-card {
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.chart-title {
  font-weight: 600;
  margin-bottom: 1rem;
  color: #5e5873;
}

@media (max-width: 768px) {
  .charts-grid {
    grid-template-columns: 1fr;
  }
}
</style>
